import { render, staticRenderFns } from "./questionContainer.vue?vue&type=template&id=b1bfddc6&scoped=true&"
import script from "./questionContainer.vue?vue&type=script&lang=js&"
export * from "./questionContainer.vue?vue&type=script&lang=js&"
import style0 from "./questionContainer.vue?vue&type=style&index=0&id=b1bfddc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bfddc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
